import { isEmpty, uniq } from 'lodash';
import { batchS3FileUpload } from 'src/services/s3';

/**
 * Uploads files to S3 and returns an array of unique URLs
 */
export async function uploadFilesToS3<T extends string[]>(
  key: string,
  files: Record<string, File>,
  data?: T
): Promise<T> {
  if (isEmpty(files)) {
    return data as T;
  }

  const uploaded = await batchS3FileUpload(key, files);

  return uniq(
    [...(data || []), ...Object.values(uploaded)].filter(
      (item) => !item.startsWith('blob:')
    )
  ) as T;
}
